import axios from "axios";
import axiosApiInstance from '../../Interceptors';

const BASE_URL =  process.env.REACT_APP_AUTH_BASE_URL + "user/";
const BRANCH = process.env.REACT_APP_ENV_RESOURCE;

const loginFunc = async(email,password,env_resource) => {
    try{
        axiosApiInstance.shouldDisableInterceptor = true;
        const res = await axios.post(BASE_URL + "login/email",{
            email,
            password,
            resource:env_resource
        });

        if(res.status === 200) {
            localStorage.setItem("email_"+BRANCH,email)
            localStorage.setItem("accessToken_"+BRANCH,JSON.stringify(res.data.accessToken));
            localStorage.setItem("refreshToken_"+BRANCH,JSON.stringify(res.data.refreshToken));
        }
        return res;
    }
    catch(err){
        console.log("Catch in loginFunc: " +err);
        // eslint-disable-next-line eqeqeq
        if(err == "AxiosError: Request failed with status code 403"){
            console.log("403");
            return "403";
        }
        
    }
};

export default loginFunc;